import { RolesSelectOptionModel } from "model/RolesSelectOption.model";

export const setTitledValue = (selectedOptions: RolesSelectOptionModel[]): string => {
  return selectedOptions.map((element) => element.title).join(" ");
};
